import React, { useEffect } from 'react';

/**
 * This component injects the tabindex attribute to the toast notification buttons/
 */
export function ToastAttributeInjector() {
    /**
     * Set tabindex for all buttons in the toast notifications
     */
    const setTabIndex = () => {
        const buttons = document.querySelectorAll('.react-toast-notifications__toast__dismiss-button'); // The react-toast-notifications class is used to identify the toast close button
        buttons.forEach(button => {
            button.setAttribute('tabindex', '0');

            // Add keydown event listener to handle Enter key
            // Avoid adding multiple listeners of the same type
            if (!button.getAttribute('data-keydown-enhanced')) {
                button.addEventListener('keydown', event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.currentTarget.click();
                    }
                });

                button.setAttribute('data-keydown-enhanced', 'true');
            }
        });

        return buttons;
    };

    /**
     * Listen for changes in the DOM and set tabindex for buttons (toast notifications)
     */
    useEffect(() => {
        const observer = new MutationObserver(() => {
            setTabIndex();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Set tabindex for existing buttons
        const buttons = setTabIndex();

        return () => {
            observer.disconnect();
        };
    }, []);

    return null;
}
